// opervex-frontend/src/Opervex/Report/StockSerialDays.js

class StockSerialDays {
  #api;

  constructor(api) {
    this.#api = api;
  }

  async schema() {
    return [
      {
        key: "productId",
        label: "Código Produto",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "productText",
        label: "Descrição Produto",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "serialNumber",
        label: "Nº Serial",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "mac",
        label: "MAC",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "depositId",
        label: "Código Depósito",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "depositText",
        label: "Texto Depósito",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "depositType",
        label: "Código Tipo Depósito",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "depositTypeText",
        label: "Texto Tipo Depósito",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "documentDate",
        label: "Data da Entrada",
        type: "dateOnly",
        visible: true,
        hidden: false,
      },
      {
        key: "days",
        label: "Dias",
        type: "number",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default StockSerialDays;
